import { FeatureFlag, useFeatureFlag } from './useFeatureFlags'
import { usePermissions } from '@/hooks/usePermissions'

import { useCreateBulkIncidentActionMutation } from '@/graphql/generated/hooks'
import { CreateBulkIncidentActionInput } from '@/graphql/generated/schemas'

const GET_INCIDENTS_QUERY_NAME = 'Incidents'

/**
 * Hook to determine if bulk actions are available for the current user
 * Checks both feature flag and user permissions
 */
export const useCanBulkAction = (): boolean => {
  const isBulkActionFeatureFlagOn: boolean = useFeatureFlag(
    FeatureFlag.bulkIncidentActions
  )
  const { canBulkAction } = usePermissions()
  return isBulkActionFeatureFlagOn && canBulkAction
}

export const useBulkAction = () => {
  const [bulkAction] = useCreateBulkIncidentActionMutation()

  const submitBulkAction = async (props: CreateBulkIncidentActionInput) => {
    return await bulkAction({
      variables: {
        input: props,
      },
      refetchQueries: [GET_INCIDENTS_QUERY_NAME],
    })
  }

  return {
    submitBulkAction,
  }
}
